import { render, staticRenderFns } from "./OtherIncomeCreationSection.vue?vue&type=template&id=59ee0c63&scoped=true"
import script from "./OtherIncomeCreationSection.vue?vue&type=script&lang=js"
export * from "./OtherIncomeCreationSection.vue?vue&type=script&lang=js"
import style0 from "./OtherIncomeCreationSection.vue?vue&type=style&index=0&id=59ee0c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ee0c63",
  null
  
)

export default component.exports